import React from 'react';
import { Link } from 'react-router-dom';
import { pathJoin } from '../../../../../services/api';
import { capText, timestampToHuman } from '../../../../../services/formatting';
import {
    QueryGrid,
    QueryGridSelectMode,
} from '../../../../shared/grid/queryGrid/queryGrid';
import { Add } from '../../../../shared/actions/actionButtons';
import { useHasPermission } from '../../../../../services/auth/auth';
import {
    CAMPAIGN_ADHOC,
    CAMPAIGN_ADHOC_TEMPLATE,
    USER,
} from '../../../../../permissions';

export const CampaignAdhocList = (props) => {
    const canReadUser = useHasPermission([USER.READ]);
    const canReadTemplate = useHasPermission([CAMPAIGN_ADHOC_TEMPLATE.READ]);

    return (
        <QueryGrid
            queryParamPrefix=''
            singleResourceName='Campaign'
            pluralResourceName='Campaigns'
            nameFunction={(r) => r.name}
            restEndpoint='/communications/campaigns/adhocs'
            listUrl='/communications/campaigns'
            actions={[Add]}
            readPermissions={[CAMPAIGN_ADHOC.READ]}
            writePermissions={[CAMPAIGN_ADHOC.WRITE, CAMPAIGN_ADHOC_TEMPLATE.READ]}
            selectMode={QueryGridSelectMode.None}
            columns={{
                reason: {
                    label: 'Reason',
                    passOnClick: true,
                    formatFunction: (r) => (
                        <Link to={pathJoin('/communications/campaigns/', r.id)}>
                            {capText(r.reason, 100)}
                        </Link>
                    ),
                },
                channel: {
                    label: 'Channel',
                    formatFunction: (r) => r.channel?.displayName,
                },
                'template.name': {
                    label: 'Template',
                    passOnClick: true,
                    formatFunction: (r) =>
                        r.template && canReadTemplate ? (
                            <Link
                                to={pathJoin(
                                    '/communications/campaigns/templates/',
                                    r.template.id
                                )}>
                                {r.template.name}
                            </Link>
                        ) : (
                            r.template.name
                        ),
                },
                'createBy.displayName': {
                    label: 'Created By',
                    formatFunction: (r) =>
                        r.createBy && canReadUser ? (
                            <Link to={pathJoin('/users', r.createBy.id)}>
                                {r.createBy.displayName}
                            </Link>
                        ) : (
                            r.createBy.displayName
                        ),
                },
                createDate: {
                    label: 'Date',
                    formatFunction: (r) => timestampToHuman(r.createDate),
                },
                contactCount: {
                    label: 'Contacts',
                    formatFunction: (r) => r.contactCount,
                },
            }}
            {...props}
        />
    );
};
